import { Grid, Paper, Button, ButtonGroup } from "@material-ui/core";
import React from "react";
import PowerChart from "./charts/power-chart";
import PowerOutBar from "./charts/power-bar";
import CellTempChart from "./charts/cell-temp-chart";
import CellVoltChart from "./charts/cell-volt-chart";
import SlaveTempChart from "./charts/slave-temp-chart";

const RealTimeChartTabs = () => {
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  const getButtonStyle = (index) => ({
    backgroundColor: selectedTab === index ? "lightgreen" : "white",
    color: "black"
  });

  return (
    <div>
      <ButtonGroup variant="contained" style={{ padding: "10px", margin: "10px" }}>
        <Button onClick={() => handleTabChange(0)} style={getButtonStyle(0)}>Cell Volt</Button>
        <Button onClick={() => handleTabChange(1)} style={getButtonStyle(1)}>Cell Temperature</Button>
        <Button onClick={() => handleTabChange(2)} style={getButtonStyle(2)}>Slave Temperature</Button>
        <Button onClick={() => handleTabChange(3)} style={getButtonStyle(3)}>Load</Button>
      </ButtonGroup>
      {selectedTab === 0 && (
        <Grid style={{ padding: "10px", margin: "10px" }}>
          <CellVoltChart />
        </Grid>
      )}
      {selectedTab === 1 && (
        <Grid style={{ padding: "10px", margin: "10px" }}>
          <CellTempChart />
        </Grid>
      )}
      {selectedTab === 2 && (
        <Grid style={{ padding: "10px", margin: "10px" }}>
          <SlaveTempChart />
        </Grid>
      )}
      {selectedTab === 3 && <PowerChart />}
    </div>
  );
};

export default RealTimeChartTabs;
